<template><div><h2 id="all-sides" tabindex="-1" class="d-docsite--header-2">All Sides <a class="header-anchor d-link d-docsite--link d-link" href="#all-sides" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-ba</code> to add a border to all sides of your element.</p>
<code-example source-code='&lt;div class=&quot;d-p-200 d-ba d-bgc-primary d-baw0&quot;&gt;d-baw0&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-bgc-primary d-baw1&quot;&gt;d-baw1&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-bgc-primary d-baw2&quot;&gt;d-baw2&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-bgc-primary d-baw4&quot;&gt;d-baw4&lt;/div&gt;'>
<dt-stack data-demo-wrapper gap="200" :direction="{ 'default': 'column', 'md': 'row' }">
  <div class="d-p-200 d-ba d-bgc-primary d-baw0">d-baw0</div>
  <div class="d-p-200 d-ba d-bgc-primary d-baw1">d-baw1</div>
  <div class="d-p-200 d-ba d-bgc-primary d-baw2">d-baw2</div>
  <div class="d-p-200 d-ba d-bgc-primary d-baw4">d-baw4</div>
</dt-stack>
</code-example>
<h2 id="individual-sides" tabindex="-1" class="d-docsite--header-2">Individual Sides <a class="header-anchor d-link d-docsite--link d-link" href="#individual-sides" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-b{t|r|b|l|x|y}</code> to add a border to only specific sides of your element.</p>
<code-example source-code='&lt;div class=&quot;d-p-200 d-baw4 d-bgc-primary d-bt&quot;&gt;d-bt&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-baw4 d-bgc-primary d-br&quot;&gt;d-br&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-baw4 d-bgc-primary d-bb&quot;&gt;d-bb&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-baw4 d-bgc-primary d-bl&quot;&gt;d-bl&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-baw4 d-bgc-primary d-bx&quot;&gt;d-bx&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-baw4 d-bgc-primary d-by&quot;&gt;d-by&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-baw4 d-bgc-primary d-ba&quot;&gt;d-ba&lt;/div&gt;'>
<dt-stack data-demo-wrapper gap="200" :direction="{ 'default': 'column', 'md': 'row' }">
  <div class="d-p-200 d-baw4 d-bgc-primary d-bt">d-bt</div>
  <div class="d-p-200 d-baw4 d-bgc-primary d-br">d-br</div>
  <div class="d-p-200 d-baw4 d-bgc-primary d-bb">d-bb</div>
  <div class="d-p-200 d-baw4 d-bgc-primary d-bl">d-bl</div>
  <div class="d-p-200 d-baw4 d-bgc-primary d-bx">d-bx</div>
  <div class="d-p-200 d-baw4 d-bgc-primary d-by">d-by</div>
  <div class="d-p-200 d-baw4 d-bgc-primary d-ba">d-ba</div>
</dt-stack>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="i in directions">
        <th scope="row" class="d-code--sm d-docsite-code">.d-b{{ i[0] }}</th>
        <td class="d-code--sm">
          <span v-if="i === 'y'">
            border-block-start: var(--dt-size-border-100) solid !important;<br/>
            border-block-end: var(--dt-size-border-100) solid !important;
          </span>
          <span v-else-if="i === 'x'">
            border-inline-end: var(--dt-size-border-100) solid !important;<br/>
            border-inline-start: var(--dt-size-border-100) solid !important;
          </span>
          <span v-else-if="i === 'all'">
            border: var(--dt-size-border-100) solid !important;
          </span>
          <span v-else>
            border-{{ i === 'top' ? 'block-start' : i === 'bottom' ? 'block-end' : i === 'left' ? 'inline-start' : i === 'right' ? 'inline-end' : i }}: var(--dt-size-border-100) solid !important;
          </span>
        </td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


<script setup>
  import { directions } from '@data/borders.json';
</script>